import * as XLSX from "xlsx";
import { getPreference } from "../../Utils/userPreferenceManger";
import { MA_SUBTABLE_COLUMNS } from "./MABranchConstants";

const getOrderedColumnsForDownload = (selectedColumns = [], sectionKey) => {
  if (!sectionKey || !Array.isArray(selectedColumns) || selectedColumns.length === 0) {
    return selectedColumns;
  }

  const savedOrder = getPreference(`columnOrder_${sectionKey}`);
  if (!Array.isArray(savedOrder) || savedOrder.length === 0) {
    return selectedColumns;
  }

  const selectedByKey = new Map(selectedColumns.map((column) => [column.key, column]));
  const orderedKeys = savedOrder
    .map((item) => (typeof item === "string" ? item : item?.key))
    .filter(Boolean);

  if (orderedKeys.length === 0) {
    return selectedColumns;
  }

  const orderedSelectedColumns = [];
  orderedKeys.forEach((key) => {
    const column = selectedByKey.get(key);
    if (column) {
      orderedSelectedColumns.push(column);
      selectedByKey.delete(key);
    }
  });

  selectedByKey.forEach((column) => orderedSelectedColumns.push(column));
  return orderedSelectedColumns;
};

const formatCellValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return value;
};

const DEALER_COLUMN_KEYS = new Set(MA_SUBTABLE_COLUMNS.map((col) => col.key));

export const downloadMAInventoryData = (
  data,
  selectedColumns,
  format = "xlsx",
  sectionKey = "ma-inventory"
) => {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      alert("No data available to download.");
      return;
    }

    const downloadableColumns = selectedColumns.filter((col) => col.key !== "actions");
    const effectiveColumns = getOrderedColumnsForDownload(downloadableColumns, sectionKey);

    const headers = effectiveColumns.map((col) => col.name);
    const rows = [];

    data.forEach((row) => {
      // Main row
      rows.push(effectiveColumns.map((col) => formatCellValue(row[col.key])));

      // Dealer sub-rows (expandable content)
      const dealers = Array.isArray(row.dealers) ? row.dealers : [];
      dealers.forEach((dealer) => {
        rows.push(
          effectiveColumns.map((col) => {
            if (DEALER_COLUMN_KEYS.has(col.key)) {
              return formatCellValue(dealer[col.key]);
            }
            // Non-dealer columns are left blank for sub-rows
            return "";
          })
        );
      });
    });

    const aoa = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "MA Inventory");

    let blob;
    let filename;
    if (format === "csv") {
      const csv = XLSX.utils.sheet_to_csv(ws);
      blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      filename = "ma_inventory_data.csv";
    } else {
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      filename = "ma_inventory_data.xlsx";
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading MA Inventory data:", error);
    alert("Failed to download data. Please try again.");
  }
};
